/* src/app/ai-sourcing/bulk-email-campaign/bulk-email-campaign.component.scss */
/*# sourceMappingURL=bulk-email-campaign.component-YF6GUNGS.css.map */
